<div class="page-layout" *transloco="let t">
  <!-- Top summary cards -->
  <div class="summary-wrapper" *ngIf="organizationWorkplaces$ | async as workplaces">
    <!-- Organization name card -->
    <div class="summary-card org-name">
      <div class="card-text-wrapper">
        <span class="title">{{ workplaces.organizationName }}</span>
      </div>
    </div>
    <!-- Organization count card -->
    <div class="summary-card">
      <div class="card-text-wrapper">
        <span class="subtitle">{{ t('settings/workplaces') }}</span>
        <span class="title">{{ workplaces.totalWorkplaces }}</span>
      </div>
      <i class="material-symbols-rounded">home</i>
    </div>
    <!-- Child count card -->
    <div class="summary-card">
      <div class="card-text-wrapper">
        <span class="subtitle">{{ t('settings/childs') }}</span>
        <span class="title">{{ totalChildrenCount$ | async }}</span>
      </div>
      <i class="material-symbols-rounded">child_hat</i>
    </div>
    <!-- Teachers count card -->
    <div class="summary-card">
      <div class="card-text-wrapper">
        <span class="subtitle">{{ t('settings/teachers') }}</span>
        <span class="title">{{ totalTeachersCount$ | async }}</span>
      </div>
      <i class="material-symbols-rounded">person</i>
    </div>
  </div>

  <!-- Items -->
  <div class="items" *ngIf="organizationWorkplaces$ | async as workplaces">
    <app-organization-workplace-item
      *ngFor="let workplace of workplaces.workplaces"
      [workplace]="workplace"
    ></app-organization-workplace-item>
  </div>
</div>
